module.exports = __webpack_public_path__ + "static/media/3.7d960e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/tmsAbout/img/3.png
// module id = 437
// module chunks = 0